import { merchantApi } from '@/config/axios'

/** B 端运力经营台 · 机构分润（merchant-api） */

export interface OrgBill {
  billId: string
  orgId: string
  period: string
  amount: number
  orderCount: number
  status: string
  disputeReason?: string
}

export interface WalletActResult {
  success: boolean
  message?: string
}

export interface CommissionEntry {
  entryId: string
  orgId: string
  waybillId: string
  amount: number
  billId?: string
  createdAt?: string
}

const BASE = '/merchant-api/capacity/wallet'

export const listOrgBills = (orgId: string) =>
  merchantApi.get<OrgBill[]>({ url: `${BASE}/org/bills`, params: { orgId } })

export const listBillLines = (orgId: string, billId: string) =>
  merchantApi.get<CommissionEntry[]>({
    url: `${BASE}/org/bills/lines`,
    params: { orgId, billId }
  })

export const confirmBill = (orgId: string, billId: string) =>
  merchantApi.post<WalletActResult>({
    url: `${BASE}/org/bills/confirm`,
    params: { orgId, billId }
  })

export const disputeBill = (orgId: string, billId: string, reason?: string) =>
  merchantApi.post<WalletActResult>({
    url: `${BASE}/org/bills/dispute`,
    params: { orgId, billId, reason }
  })

export const disputeBillLine = (
  orgId: string,
  billId: string,
  waybillId: string,
  reason?: string
) =>
  merchantApi.post<WalletActResult>({
    url: `${BASE}/org/bills/dispute-line`,
    params: { orgId, billId, waybillId, reason }
  })
